import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import styled from 'styled-components';
import { withFormik } from 'formik';
import * as yup from 'yup';
import { withTranslation } from 'react-i18next';

import { capfl } from 'common/utils';

import { setPageData, togglePageModal } from 'common/actions/PageActions';
import { fetchPossibleDeliveries } from 'common/actions/ReservationActions';
import { addToCart } from 'common/actions/CartActions';

import { ESHOP_TYPE_B2B_LOCKED, ALLOW_ORDER_OUT_OF_STOCK } from 'common/constants/SiteConstants';

import { getWebInstanceEshopTypeSelector, getWebInstanceSettingsSelector } from 'common/selectors';
import { isUserLoggedSelector } from 'common/selectors/user';
import { reactiveTemplateConfigSelector } from 'common/selectors/theme';

import loadable from '@loadable/component';
const ProductFormVariant = loadable(props =>
  import(`common/blocks/product/detail/form/${props.blockVariant}`)
);

const S = {};
S.UnableToOrder = styled.section`
  border-top: ${({ theme }) => _.get(theme, 'border.default.width')}
    ${({ theme }) => _.get(theme, 'border.default.style')}
    ${({ theme }) => _.get(theme, 'border.default.color')};
  padding: 15px;
  margin: 0;
  font-weight: bolder;
`;

class ProductForm extends PureComponent {
  submitFormEvent() {
    const { setSubmitting, submitForm } = this.props;
    setSubmitting(true);
    submitForm();
  }
  onShowReservationModalClick = e => {
    e.preventDefault();
    const { showReservationModal, product } = this.props;
    showReservationModal(product);
  };
  render() {
    const { blockVariant, product, eshopType, isLogged = false, allowOrderOutOfStockProducts, t, ...rest } = this.props;
    const { store = [], isOrderable } = product;
    if (!isLogged && eshopType === ESHOP_TYPE_B2B_LOCKED) {
      return null;
    }
    if (!((isOrderable || _.isUndefined(isOrderable)) && !_.isEmpty(store))) {
      return (
        <S.UnableToOrder>
          {capfl(t("sorry, you can't order this product right now"))}
        </S.UnableToOrder>
      );
    }
    return (
      <ProductFormVariant
        product={product}
        blockVariant={blockVariant}
        isLogged={isLogged}
        allowOrderOutOfStockProducts={allowOrderOutOfStockProducts}
        t={t}
        {...rest}
      />
    );
  }
}

const getFormMessages = t => {
  return {
    size: { required: capfl(`${t('size')} ${t('is required')}!`) },
    count: {
      required: capfl(`${t('count')} ${t('is required')}!`)
    }
  };
};

const formikEnhancer = withFormik({
  isInitialValid: true,
  enableReinitialize: true,
  mapPropsToValues: props => {
    const { product } = props;
    return {
      size: _.get(product, 'store[0].id', null),
      count: 1
    };
  },
  validationSchema: ({ t }) => {
    const messages = getFormMessages(t);
    return yup.object().shape({
      size: yup.mixed().required(messages.size.required),
      count: yup.number().required(messages.count.required)
    });
  },
  handleSubmit: (values, { props, setSubmitting }) => {
    const { product, showProductHooksModal, addItemToCart } = props;
    const { id, productHooks } = product;
    const { size, count } = values;
    addItemToCart(id, size, count);
    if (!_.isEmpty(productHooks)) {
      showProductHooksModal();
    }
    setSubmitting(false);
  }
});

const EnhancedProductForm = formikEnhancer(ProductForm);

const makeMapStateToProps = () => {
  const getWebInstanceSettings = getWebInstanceSettingsSelector();
  const getWebInstanceEshopType = getWebInstanceEshopTypeSelector();
  const isUserLogged = isUserLoggedSelector();
  const reactiveTemplateConfig = reactiveTemplateConfigSelector(
    'ProductFormVariant'
  );
  return (state, props) => {
    return {
      allowOrderOutOfStockProducts: _.toNumber(_.get(getWebInstanceSettings(state, props), ALLOW_ORDER_OUT_OF_STOCK)),
      eshopType: _.toNumber(getWebInstanceEshopType(state, props)),
      isLogged: isUserLogged(state, props),
      blockVariant: reactiveTemplateConfig(state, props)
    };
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showProductHooksModal: () => {
      dispatch(togglePageModal('product_hooks', true));
    },
    addItemToCart: (id, sizeId, count) => {
      dispatch(addToCart({ productId: id, sizeId, count }));
    },
    showReservationModal: product => {
      dispatch(fetchPossibleDeliveries(product));
      dispatch(togglePageModal('product_reservation', true));
    },
    setSizeForReservation: values => {
      dispatch(setPageData(values, 'reservation', 'size'));
    },
    setCountForReservation: value => {
      dispatch(setPageData(value, 'reservation', 'count'));
    }
  };
};

const EnhancedProductFormConnected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(EnhancedProductForm);

export default withTranslation()(EnhancedProductFormConnected);
